import api from "./axios";
import {
  type Truck,
  type TruckSearchFilters,
  mapTrucksResponse,
  mapTruckResponse,
} from "../types/truck";
import { type PaginationResponse, mapPaginationResponse } from "../types/paginationResponse";
import type { PaginationParam } from "../types/paginationResponse";
import { buildPaginationQuery } from "../utils/pagination";
export interface CreateTruckResponse {
  data: Truck;
}

export interface SearchTrucksResponse {
  trucks: Truck[];
  pagination: PaginationResponse;
}

export const getTrucksApi = async (): Promise<Truck[]> => {
  try {
    const response = await api.get<any>("/api/v1/trucks");
    return mapTrucksResponse(response.data);
  } catch (error) {
    console.error("Error fetching trucks:", error);
    throw error;
  }
};

export const searchTrucksApi = async (
  filters?: TruckSearchFilters,
  pagination?: PaginationParam,
  retired: "only" | "exclude" | "include" = "exclude",
): Promise<SearchTrucksResponse> => {
  try {
    const queryString = buildPaginationQuery(pagination);
    const url = `/api/v1/trucks/search${queryString}`;
    const response = await api.post<any>(url, { ...filters, retired });
    return {
      trucks: mapTrucksResponse(response.data),
      pagination: mapPaginationResponse(response.data.data.pagination),
    };
  } catch (error) {
    console.error("Error searching trucks:", error);
    throw error;
  }
};

export const createTruckApi = async (truckData: {
  licensePlate: string;
  type: string;
}): Promise<Truck> => {
  try {
    const cleanLicensePlate = truckData.licensePlate.replace(/\s/g, "");
    const response = await api.post<any>("/api/v1/trucks", {
      ...truckData,
      licensePlate: cleanLicensePlate,
    });
    return mapTruckResponse(response.data.data);
  } catch (error) {
    console.error("Error creating truck:", error);
    throw error;
  }
};

export const retireTruckApi = async (truckId: string, notes?: string): Promise<Truck> => {
  try {
    const response = await api.post<any>(`/api/v1/trucks/${truckId}/retire`, { notes });
    return mapTruckResponse(response.data.data);
  } catch (error) {
    console.error("Error retiring truck:", error);
    throw error;
  }
};

export const unretireTruckApi = async (
  truckId: string,
  notes?: string,
  cityId?: string,
): Promise<Truck> => {
  try {
    const response = await api.post<any>(`/api/v1/trucks/${truckId}/unretire`, { notes, cityId });
    return mapTruckResponse(response.data.data);
  } catch (error) {
    console.error("Error unretiring truck:", error);
    throw error;
  }
};
